<mat-drawer #drawer class="sidenav-filters" mode="over" position="end" (keydown.escape)="close('escape')">

  <form name="filterForm" [formGroup]="filtro" (ngSubmit)="onSubmit()" class="filterForm" novalidate>
    <h2><b>Filtros</b></h2>


    <mat-form-field class="roleSelect">
      <mat-label>Usuario</mat-label>
      <mat-select formControlName="usuario" multiple>
          <mat-option *ngFor="let usuario of usuarios" [value]="usuario">
              {{usuario.nombreCompleto}}
          </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="estructura">
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="tiposLog" multiple>
          <mat-option *ngFor="let tipo of tipos" [value]="tipo">
              {{tipo}}
          </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Fecha</mat-label>
      <mat-date-range-input [formGroup]="filtro" [rangePicker]="picker">
        <input matStartDate formControlName="fechaInicioDesde" placeholder="Inicio">
        <input matEndDate formControlName="fechaInicioHasta" placeholder="Fin">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>


    <button class="formButton primary" mat-raised-button color="primary" type="submit">Aplicar</button>
    <button class="formButton secondary" mat-raised-button color="secondary" (click)="clean()">Limpiar Filtros</button>
  </form>
</mat-drawer>

<div class="toggle-button">
  <button type="button" mat-mini-fab (click)="drawer.toggle()">
    <mat-icon aria-hidden="false" aria-label="filters">filter_list</mat-icon>
  </button>
</div>
<!-- TOP BACKGROUND -->
<div class="top-bg accent"></div>
<!-- / TOP BACKGROUND -->
